import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebase-client';
import { normalizeLearnToSailSignupMode } from '../teams/utils/learnToSail';

function mergeCourseSnapshots(results = []) {
  const byId = new Map();
  results.forEach((result) => {
    if (result.status !== 'fulfilled') return;
    result.value.docs.forEach((docSnap) => {
      byId.set(docSnap.id, { id: docSnap.id, ...docSnap.data() });
    });
  });
  return Array.from(byId.values())
    .filter((course) => course.status !== 'cancelled' && normalizeLearnToSailSignupMode(course) === 'open_to_all');
}

export async function loadPublicLearnToSailCourses(teamId) {
  const coursesRef = collection(db, 'teams', teamId, 'learnToSailCourses');
  const results = await Promise.allSettled([
    getDocs(query(coursesRef, where('publicSignupEnabled', '==', true))),
    getDocs(query(coursesRef, where('signupMode', '==', 'open_to_all'))),
  ]);

  if (results.every((result) => result.status === 'rejected')) {
    throw results[0].reason;
  }

  return mergeCourseSnapshots(results);
}
